import { Component, ViewChild, OnInit, OnChanges, OnDestroy, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ExportDataService } from '../../../../shared';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { environment } from '../../../../../environments/environment';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ProposalPopupComponent } from '../ot-labor-proposal/prop-table/proposal-popup/proposal-popup.component';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { NgStyle } from '@angular/common';
import { CapitalInvestmentSummaryLeaderComponent } from '../capital-investment-summary-leader/capital-investment-summary-leader.component';
import { CapitalMaintenanceComponent } from '../capital-maintenance/capital-maintenance.component';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FundMaintenanceV4Component } from '../fund-maintenance-table/fund-maintenance-table.component';
import { HeirarchyMismatchComponent } from '../heirarchy-mismatch/heirarchy-mismatch.component';
import { CapitaldemandBulkEditComponent } from '../capitaldemand-bulk-edit/capitaldemand-bulk-edit.component';
import { OtLaborProposalComponent } from '../ot-labor-proposal/ot-labor-proposal/ot-labor-proposal.component';
import { AppModalComponent } from '../../../../shared/elements/app-modal/app-modal.component';
import { AddSegmentComponent } from './add-segment/add-segment.component';

@Component({
    selector: 'app-fund-maintenance',
    templateUrl: './fund-maintenance.component.html',
    styleUrl: './fund-maintenance.component.scss',
    imports: [MatTabGroup, MatTab, RouterLink, NgStyle, CapitalInvestmentSummaryLeaderComponent, CapitalMaintenanceComponent, MatFormField, MatInput, FormsModule, FundMaintenanceV4Component, HeirarchyMismatchComponent, CapitaldemandBulkEditComponent, OtLaborProposalComponent, AppModalComponent, AddSegmentComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class FundMaintenanceComponent implements OnChanges, OnDestroy, OnInit {
  @ViewChild('modalAddSegment', { static: false }) modalAddSegment;
  @ViewChild('proposalPopupComponent') proposalPopupComponent!: ProposalPopupComponent; // Reference to the prop-table component
  tabSwitched: boolean = false;
  author: any;
  public capitalDemnadList: MatTableDataSource<any>;
  singleRow: any = {
    author: ''
  }
  public Records: any = [];
  capitalDemandRecords: any = [];
  rowsToDelete: any = [];
  rowsToExport: any = [];
  searchString: string;
  deleteGrpRes: any;
  deleteGrpRecoredRes:any;
  sort:any = null;
  restrictionEdit:boolean = false;
  userWithAccess :boolean = false;
  isAddSegment:boolean = false;
  isEditSegment:boolean = false;
  capitalDemandOwners :any;
  bulkEdit:any
  hierarchyMismatch :any;
  otProposal: any;
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc',
  }
  dataSourceDetails: any;
  capitalDemandInvestment: any;
  proposalReqId: any;
  selectedIndex: number = 0; // Add this property to track the active tab
  checked = false;
  clearFilters: boolean = false;
  tabs: Array<any> = [
    { label: 'Investment Summary' },
    { label: 'Segment Owners' },
    { label: 'OT Labor Proposal' },
    { label: 'Hierarchy Mismatch' },
    { label: 'Bulk Edit' }
  ];
  private originalRouteReuseStrategy: any;

  constructor(
    public exportService: ExportDataService,
    public toaster: ToastrService, 
    public maintenanceService: MaintenanceService,
    private route: ActivatedRoute,
    private router: Router,
     public sharedAuthService: SharedAuthService, // Inject ActivatedRoute
  ) {
    this.originalRouteReuseStrategy = this.router.routeReuseStrategy.shouldReuseRoute;
    this.router.routeReuseStrategy.shouldReuseRoute = (future, curr) => {
      return future.routeConfig === curr.routeConfig;
    };
  }

  ngOnInit() {
    //access query param here
    this.capitalDemandInvestment = { isActive: false };
    this.capitalDemandOwners = { isActive: false };
    this.hierarchyMismatch = { isActive: false };
    this.bulkEdit = { isActive: false };
    this.otProposal = { isActive: false };

    this.capitalDemandList();
    this.author = JSON.parse(sessionStorage.getItem('loggedInUserEmail'));
    this.fundOwnerRestrictionEdit();

    // Access query parameters
    this.route.queryParams.subscribe(params => {
      console.log('Query Params:', params);
      this.proposalReqId = params['Request_Id']; // Replace 'someParam' with your query param key
      console.log('Value of someParam from init:', this.proposalReqId);
      if (params['leaderView']=='true'){ 
        this.checked = true;
      } else if (params['tab']) {
        this.tabChange({index: Number(params['tab'])});
      } else if(params['selectedTab']){
        const tabIndex = this.tabs.findIndex(tab => tab.label.replace(/ /g, '-') === params['selectedTab']);
        if (tabIndex !== -1) {
          this.selectedIndex = tabIndex;
          this.tabChange({index: tabIndex});
        }
      }
      else{
        this.checked = false;
      }
    });
    if (this.proposalReqId) {
      this.selectedIndex = 2; // Set the selectedIndex to the desired tab
      this.tabChange({index: 2}); // Switch to the 'OT Proposal' tab if Request_Id is present
    }
  }
  ngOnChanges() {
    this.fundOwnerRestrictionEdit();

        // Access query parameters
        this.route.queryParams.subscribe(params => {
          console.log('Query Params:', params);
          const someParam = params['Request_Id']; // Replace 'someParam' with your query param key
          console.log('Value of someParam from changes:', someParam);
        });
  }
  capitalDemandList() {
    this.searchString = '';
    this.maintenanceService.getCapitalDemandList().subscribe((res: any) => {
      this.capitalDemnadList = new MatTableDataSource(res);
      this.capitalDemandRecords = res;
      this.Records = res;
      this.capitalDemnadList.filterPredicate = function (record, filter) {
        return record.groupname.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1;
      }
      this.fundOwnerRestrictionEdit();
    }, (err) => {
        console.log(err);
      });
    
  }
  searchDataSet(event) {
    const filterValue = event ? (event.target as HTMLInputElement).value : '';
    this.searchString = filterValue;
  }

  fundOwnerRestrictionEdit() {
    this.restrictionEdit = this.sharedAuthService.getFundingAccessDetails('');
    const segmentsAccess = this.sharedAuthService.getFundingAccessDetails('Segmentlist');
    const ucmgAccess = this.sharedAuthService.getUCMGAccessDetails();
    this.userWithAccess = this.restrictionEdit || (Array.isArray(segmentsAccess) && segmentsAccess.length > 0)
                          || (Array.isArray(ucmgAccess) && ucmgAccess.length > 0);
  }

  hidepopup(type) {
    if(type === 'addSegment') {
      this.isAddSegment = false;
      this.modalAddSegment.hide();
    }
  }

  AddSegment() {
    this.isAddSegment = true;
    this.modalAddSegment.show();
  }

  segmentSubmit(event) {
    if(event) {
      this.hidepopup('addSegment')
      this.capitalDemandList();
    }
  } 

  segemntDelRefrash(event) {
    if(event) {
      this.capitalDemandList();
    }
  }

  showDoc(){
    let docValue

    const selectedIndex = this.selectedIndex;
    if (selectedIndex === 0 && this.capitalDemandInvestment) {
        docValue = '' ;
    } else if (selectedIndex === 1 && this.capitalDemandOwners) {
        docValue = this.capitalDemandOwners.isActive ? 'segment-owners' : '';
    } else if (selectedIndex === 2 && this.otProposal) {
      docValue = this.otProposal.isActive ? 'ot-labor-proposal' : '';
    } else if (selectedIndex === 3 && this.hierarchyMismatch) {
        docValue = 'hierarchy-mismatch';
    } else if (selectedIndex === 4 && this.bulkEdit) {
        docValue = this.bulkEdit.isActive ? 'bulk-edit' : '';
    }
    const link = environment.docUrl + 'user-guide/Capital-Demand/#' + docValue;
    window.open(link);
  }
 
  segmentRefreashData(event) {
    if(event) {
      this.capitalDemandList();
    }
  }

  exportToExcel() {
    const exportData = [];
    if (this.capitalDemnadList.data.length == 0) {
      return;
    }
    this.capitalDemnadList.data.forEach((element) => {
      const exportJSON: any = {};
      const fundingData: any = [];
      const findingDeligate: any = [];
      exportJSON['Funding Source'] = element.Funding_Source || null;
      exportJSON['Funding SegmentID'] = element.Funding_SegmentID || null;
      exportJSON['Funding Segment'] = element.Funding_Segment || null;
      element.Funding_Owner.forEach((item) => {
        fundingData.push(item.displayName.replace(', ', ' '));
      });
      exportJSON['Funding Owner'] = fundingData.join(', ');
      element.Funding_Delegate.forEach((item) => {
        findingDeligate.push(item.displayName.replace(', ', ' '));
      });
      exportJSON['Funding Delegate'] = findingDeligate.join(', ');
      exportData.push(exportJSON);
    });
    this.exportService.exportToExcel('Funding Owner', [exportData])
  }
  tabChange(event: any) {
    this.selectedIndex = event.index; // Update the selectedIndex when the tab changes
    this.searchString = '';
    this.searchDataSet('');
    this.tabSwitched = !this.tabSwitched;
    localStorage.removeItem('capitalDemandLeaderKPIValues');
    localStorage.removeItem('filteredData');
    localStorage.removeItem('selectedHierarchyItems');
    localStorage.removeItem('capitalDemandLeaderSelectedstatus');
    this.checked = false;

    // Reset filters in capital-maintenance component when switching away from Investment Summary tab
    if (event.index !== 0) {
      this.clearFilters= true;
    }

    // Reset isActive for all tabs
    if (this.capitalDemandInvestment) this.capitalDemandInvestment.isActive = false;
    if (this.capitalDemandOwners) this.capitalDemandOwners.isActive = false;
    if (this.hierarchyMismatch) this.hierarchyMismatch.isActive = false;
    if (this.bulkEdit) this.bulkEdit.isActive = false;
    if (this.otProposal) this.otProposal.isActive = false;

    // Set isActive for the selected tab
    const selectedIndex = event.index;
    if (selectedIndex === 0 && this.capitalDemandInvestment) {
        this.capitalDemandInvestment.isActive = true;
    } else if (selectedIndex === 1 && this.capitalDemandOwners) {
        this.capitalDemandOwners.isActive = true;
    } else if (selectedIndex === 2 && this.otProposal) {
      this.otProposal.isActive = true;
    } else if (selectedIndex === 3 && this.hierarchyMismatch) {
        this.hierarchyMismatch.isActive = true;
    } else if (selectedIndex === 4 && this.bulkEdit) {
        this.bulkEdit.isActive = true;
    }
    // Remove all query parameters from the URL
    const urlWithoutQueryParams = this.router.url.split('?')[0];
    const newUrl = `${urlWithoutQueryParams}`;
    const queryParams: any = {
      selectedTab: this.tabs[event.index].label.replace(/ /g, '-')
    };
    // Only merge params for OT Labor Proposal tab, otherwise replace
    const navigationExtras: any = {
      queryParams: queryParams
    };
    if (event.index === 2) { // OT Labor Proposal tab
      navigationExtras.queryParamsHandling = 'merge';
    }
    this.router.navigate([], navigationExtras);
  }

  toggleSelectionChanged(event: any) {
    this.checked = event;

  }

  ngOnDestroy() {
    if (this.originalRouteReuseStrategy) {
      this.router.routeReuseStrategy.shouldReuseRoute = this.originalRouteReuseStrategy;
    }
    // localStorage.removeItem('capitalDemandLeaderKPIValues');
    // localStorage.removeItem('filteredData');
    // localStorage.removeItem('selectedHierarchyItems');
    // localStorage.removeItem('capitalDemandLeaderSelectedstatus');
  }
}


